import { render } from "./CustomerDialogTablesData.vue?vue&type=template&id=4d207760&scoped=true"
import script from "./CustomerDialogTablesData.vue?vue&type=script&lang=js"
export * from "./CustomerDialogTablesData.vue?vue&type=script&lang=js"

import "./CustomerDialogTablesData.vue?vue&type=style&index=0&id=4d207760&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d207760"]])

export default __exports__